export default __webpack_public_path__ + "static/media/fauna-user-research.ab3cebf7.png";